import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/index';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalComponent implements OnDestroy {
  visible$ = new BehaviorSubject(false);
  @Input() redirectRoute = '';

  constructor(private router: Router) {}

  ngOnDestroy(): void {
    this.visible$.next(false);
  }

  show() {
    this.visible$.next(true);
  }

  hide() {
    this.visible$.next(false);
    if (this.redirectRoute) {
      void this.router.navigate([{ outlets: { primary: this.redirectRoute } }]);
    }
  }
}
